import {
  BonusConfigurationModel,
  BonusConfigurationModelKeys,
} from '@/app/models/timesheet/bonusConfigurationModel'

export const TABLE_ALLOWANCES_COLSPAN = {
  NAME: 3,
  RATE: 1,
  QUANTITY: 1,
  TOTAL: 1,
  ALL: 6,
}

type Col = {
  label: string
  rateName: BonusConfigurationModelKeys
  quantityName: BonusConfigurationModelKeys
}

const TABLE_ALLOWANCES_COL_KEYS: string[] = [
  'timesheet.allowance-third-shift',
  'timesheet.allowance-third-shift',
  'timesheet.allowance-abroad',
  'timesheet.allowance-domestic',
  'timesheet.allowance-import-single',
  'timesheet.allowance-import-multiple',
  'timesheet.allowance-import-heavy',
  'timesheet.allowance-other',
]

export const TABLE_ALLOWANCES_CHECKBOX_KEY = 'timesheet.remember-rates-for-all'
export const TABLE_ALLOWANCES_CHECKBOX_NAME = 'rememberRatesForAllDrivers'

export const getAllowancesTableConfig = (
  t: (key: string) => string,
  props: { useValuesFromContract: boolean },
): Col[] => {
  return TABLE_ALLOWANCES_COL_KEYS.map((key) => {
    return {
      label: t(key),
      rateName: 'benefitsGrossAmount',
      quantityName: 'benefitsGrossAmount',
    }
  })
}
